import React from 'react';

const SignUpOnboardingStep = ({ step = 1, total = 3 }) => {
  return (
    <div style={{ display: 'flex', marginBottom: '20px' }}>
      {Array.from({ length: total }, (_, i) => i + 1).map((item) => (
        <div
          key={item}
          style={{
            width: total === 3 ? '33.33%' : total === 2 ? '50%' : '25%',
            height: '6px',
            background: step === item ? '#01796b' : '#f5f5f7',
            marginRight: '5px',
            borderRadius: '5px',
          }}
        />
      ))}
    </div>
  );
};

export default SignUpOnboardingStep;
